import { z } from 'zod';

export const categorySchema = z.object({
  id: z.string().uuid(),
  italian: z.string(),
})

export type Category = z.infer<typeof categorySchema>
